import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class KnowledgeActivityId extends IdValueObject {
  static create(value: string): KnowledgeActivityId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new KnowledgeActivityId(value);
  }
}
